import { Controller } from "stimulus";

export default class extends Controller {
  static values = { data: Object }; // Expecting a parsed JSON object directly
  static targets = ["container"];

  connect() {
    this.render();
  }

  render() {
    this.containerTarget.innerHTML = ""; // Clear previous content

    const isRenderable =
      this.dataValue &&
      typeof this.dataValue === "object" &&
      Object.keys(this.dataValue).length > 0;

    if (isRenderable) {
      const topLevelToggle = document.createElement("span");
      topLevelToggle.classList.add("json-viewer-toggle", "json-viewer-toplevel-toggle");
      topLevelToggle.style.cursor = "pointer";
      topLevelToggle.dataset.action = "click->json-viewer#toggleTopLevel";
      topLevelToggle.textContent = "[+] Show more"; // Initial state: collapsed

      const treeContentDiv = document.createElement("div");
      treeContentDiv.classList.add("json-viewer-toplevel-content", "json-viewer-collapsed");

      const tree = this.buildTree(this.dataValue);
      treeContentDiv.appendChild(tree);

      this.containerTarget.appendChild(topLevelToggle);
      this.containerTarget.appendChild(treeContentDiv);
    } else {
      this.containerTarget.textContent =
        this.dataValue === null || this.dataValue === undefined ? "(no details)" : "(empty)";
    }
  }

  buildTree(data) {
    const ul = document.createElement("ul");
    ul.classList.add("json-viewer-list");

    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const value = data[key];
        const li = document.createElement("li");
        li.classList.add("json-viewer-item");

        const keySpan = document.createElement("span");
        keySpan.classList.add("json-viewer-key");
        keySpan.textContent = `${key}: `;
        li.appendChild(keySpan);

        if (typeof value === "object" && value !== null) {
          const toggleSpan = document.createElement("span");
          toggleSpan.classList.add("json-viewer-toggle");
          toggleSpan.textContent = "[+] "; // Initial state: collapsed
          toggleSpan.style.cursor = "pointer";
          toggleSpan.dataset.action = "click->json-viewer#toggleNode";
          keySpan.insertBefore(toggleSpan, keySpan.firstChild); // Prepend toggle to key

          const nestedUl = this.buildTree(value);
          nestedUl.classList.add("json-viewer-nested", "json-viewer-collapsed");
          li.appendChild(nestedUl);
        } else {
          const valueSpan = document.createElement("span");
          valueSpan.classList.add("json-viewer-value");
          valueSpan.textContent = JSON.stringify(value);
          li.appendChild(valueSpan);
        }
        ul.appendChild(li);
      }
    }
    return ul;
  }

  toggleNode(event) {
    event.stopPropagation(); // Prevent event from bubbling up to parent nodes
    const toggleSpan = event.currentTarget;
    const nestedUl = toggleSpan.closest(".json-viewer-item").querySelector(".json-viewer-nested");

    if (nestedUl) {
      nestedUl.classList.toggle("json-viewer-collapsed");
      if (nestedUl.classList.contains("json-viewer-collapsed")) {
        toggleSpan.textContent = "[+] ";
      } else {
        toggleSpan.textContent = "[-] ";
      }
    }
  }

  toggleTopLevel(event) {
    event.stopPropagation();
    const toggleSpan = event.currentTarget;
    const treeContentDiv = toggleSpan.parentElement.querySelector(".json-viewer-toplevel-content");

    if (treeContentDiv) {
      treeContentDiv.classList.toggle("json-viewer-collapsed");
      if (treeContentDiv.classList.contains("json-viewer-collapsed")) {
        toggleSpan.textContent = "[+] Show more";
      } else {
        toggleSpan.textContent = "[-] Hide";
      }
    }
  }
}
